import { Info } from "@phosphor-icons/react";

import type { BillingEstimate } from "features/subscriptions/types";
import { formatPrice, parseEstimate } from "features/subscriptions/utils";

import Skeleton from "common/components/ui/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function ToPayNow({
  estimate,
  isLoading,
}: {
  estimate: BillingEstimate | undefined;
  isLoading: boolean;
}) {
  let previousPriceComponent: JSX.Element;
  let toPayNowAmount: number;

  if (estimate) {
    if ("invoice_estimate" in estimate && estimate.invoice_estimate) {
      const { amountDue, coupon, creditsApplied } = parseEstimate(
        estimate.invoice_estimate,
      );

      toPayNowAmount = amountDue;

      if (coupon || creditsApplied) {
        let previousPrice = amountDue + creditsApplied;

        if (coupon) {
          previousPrice += coupon.amount;
        }
        previousPriceComponent = (
          <span className="text-md-medium text-black-500 line-through">
            {formatPrice(previousPrice)}
          </span>
        );
      }
    } else {
      toPayNowAmount = 0;
    }
  }

  return (
    <div className="flex items-center justify-between px-2.5">
      <div className="flex gap-x-0.5 items-center">
        <span className="text-md-bold">To pay now</span>
        <Tooltip>
          <TooltipTrigger>
            <Info weight="fill" className="text-black-300 size-4" />
          </TooltipTrigger>
          <TooltipContent>
            The amount required to immediately update your subscription. For
            changes made in the middle of your billing cycle, this amount will
            be prorated based on your next renewal date
          </TooltipContent>
        </Tooltip>
      </div>

      <div className="flex gap-x-2 items-center">
        {isLoading ? (
          <Skeleton className="h-8 w-24" />
        ) : (
          <>
            {previousPriceComponent}
            <span className="text-2xl-bold text-purple-600">
              {toPayNowAmount === undefined ? "-" : formatPrice(toPayNowAmount)}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
